import appStylesheetUrl from './App.css?url';

// Single source for <head> meta via <Meta /> — do not duplicate with raw <meta> in Layout (hydration mismatch).
export const meta = () => [
  { charSet: 'utf-8' },
  { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
  {
    title: 'B1LINK - Procurement & Compliance Platform | Connect Faster, Grow Smarter'
  }
];

export function links() {
  return [{ rel: 'stylesheet', href: appStylesheetUrl }];
}

/** SPA build-time shell; keep in sync with Root's `null` output until `clientMounted` flips. */
export function HydrateFallback() {
  return null;
}
